import { Button } from 'antd';
import styled from "styled-components";
import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const Style = styled.div`
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  padding: 35px 40px;
  border-radius: 4px;
  background: white;
  display: flex;
  justify-content: space-between;
  gap: var(--size);
  min-width: 520px;
  min-height: 193px;

  .flex-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .icon {
    width: 55px;
    height: 55px;
    background: rgba(61, 142, 219, 0.15);
    border-radius: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .icon-body {
      margin-left: auto;
      margin-right: auto;
      width: 43px;
      height: 43px;
      background: rgba(61, 142, 219, 0.25);
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 100%;

      svg {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .body {
    h1 {
      font-size: var(--font-size-lg);
      font-weight: 600;
      margin-bottom: 4px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: #667085;
      margin-bottom: 0px;
    }
  }

  .ant-btn {
    border-radius: 6px;
    height: 46px;
    width: 120px;
  }

  .btn-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0;
    text-align: right;
  }
`;

export const EmptyState = ({ t = (s) => s, conf = {} }) => (
  <Style>
    <div className="flex-column">
      <div className="body">
        <h1>{t(conf.group === 'dataClient' ? 'New information client' : 'New information source')}</h1>
        <p>
          {t(conf.group === 'dataClient' ? 'Click the button to add a new client' : 'Click the button to add a new source')}
        </p>
      </div>
    </div>
    <div className="btn-cont">
      <Link to={`${window.location.pathname.replace('viewdd', 'editdd')}?mode=new`}>
        <Button type="primary" size="large" icon={<PlusOutlined />}>
          {t('Add')}
        </Button>
      </Link>
    </div>
  </Style>
);
